// Components
import Login from "../Components/Login";

export default function LoginPage() {
  return (
    <>
      <div className="lg:grid grid-cols-12 lg:bg-dashboard h-screen">
        <div className="col-span-7 hidden lg:block">
          <div className="h-full place-content-center bgLogin px-10">
            <h3 className="text-7xl font-semibold text-secondary">
              Precision-Driven Revenue Cycle Management
            </h3>
            <h5 className="text-4xl font-medium text-secondary mt-8">
              Optimize claims. Minimize delays. Maximize revenue.
            </h5>
          </div>
        </div>
        <div className="col-span-5 h-full">
          <div className="h-full place-content-center bg-white p-10">
            <Login />
          </div>
        </div>
      </div>
    </>
  );
}
